// @flow

import { type IncomingPayment } from './types';

export function getRedirectUrlAfterPayment(incomingPayment: IncomingPayment): ?string {
  if (incomingPayment.status === 'OP')
    throw new Error(`IncomingPayment: there is no "redirect_url_after_payment" key in a "${incomingPayment.status} payment`);

  return incomingPayment['redirect_url_after_payment'];
}
